import CARRIERS from '../../../../constants/operating-carriers';
import FARES from '../../../../constants/fare-types';
import REGIONS from '../../../../constants/region-type';

export default ({
  cart,
  flightItineraryType,
  legCollection,
  reservationStatus,
  products = [],
  paymentSelected,
  userProfile,
}) => {
  const {
    paymentCPPoints,
    travelerCollection,
    total,
    totalCPPoints,
  } = cart;

  const numberOfTravelers = travelerCollection.length;
  const isRoundTrip = flightItineraryType && flightItineraryType === 'ROUNDTRIP';
  const flightType = isRoundTrip ? 'RT-' : flightItineraryType === 'ONEWAY' ? 'OW' : 'MC';

  if (reservationStatus && reservationStatus === 'ON_HOLD') {
    const priceByLeg = cart.getCostByLegForOnHold(legCollection.length);

    legCollection.forEach((leg, index)=>{
      const segments = leg.segmentsCollection;
      const totalSgmentsByLeg = segments.length;
      const marketingCarrier = totalSgmentsByLeg ? segments[0].marketingCarrier : 'AM';
      const legDepartureArrive = `${segments[0].departureAirport}-${segments[(totalSgmentsByLeg - 1)].arrivalAirport}`;
      const travelersCode = cart && cart.travelersCode ? cart.travelersCode : 'A1_C0_I0_PH0_PC0';
      const fareFamily = totalSgmentsByLeg ? segments[0].fareFamily : 'NA';
      const arrivalSegment = !isRoundTrip ? '' : index === 0 ? 'IDA' : 'VUELTA';
      const flightNumbers = [];
      let marketingFlight = REGIONS.REGIONS_OF_FLIGHT[leg.marketFlight];

      const timeToDeparture = segments[0].departureDateTime.format('YYYYMMDDHHmm');
      const timeToArrive    = segments[(totalSgmentsByLeg - 1)].arrivalDateTime.format('YYYYMMDDHHmm');
      const aircraftType = segments[0].aircraftType;

      if ( marketingFlight === 'Transborder' ) {
        marketingFlight += leg.regionKey && leg.regionKey === 'USA' ? ' US' : ' CA';
      }

      segments.forEach((segment) => {
        flightNumbers.push(segment.marketingFlightCode);
      });

      products.push({
        name: isRoundTrip ? 'Round Trip' : flightItineraryType === 'ONEWAY' ? 'One Way' : 'Multi-city',
        id: legDepartureArrive,
        price: priceByLeg,
        brand: CARRIERS[marketingCarrier],
        category: `Flight/Flight/${legDepartureArrive}/${travelersCode}|${timeToDeparture}:${timeToArrive}|${FARES.FARE_FAMILIES_NAMES[fareFamily]}|${(flightType + arrivalSegment)}|${( flightNumbers.join(':') )}/${marketingFlight}|${aircraftType}`,
        variant: 'NA',
        quantity: numberOfTravelers,
      });
    });
  }

  const typeofPayment = (cart.hasUnpaidAncillary() || cart.hasUnpaidSeat()) && (cart.hasUnpaidAncillaryPP() || cart.hasUnpaidSeatPP()) ? 'With points and money' : (cart.hasUnpaidAncillary() || cart.hasUnpaidSeat()) ? 'Money' : 'Points';
  const typeofPaymentOnHoldPointsOrNormalFlowMYB = reservationStatus === 'ON_HOLD' && paymentCPPoints ? 'pay with points' :  typeofPayment;
  const pointsValue = reservationStatus === 'ON_HOLD' && paymentCPPoints ? totalCPPoints : total.totalCPPoints;
  const action = paymentSelected.includes('EMD') ? 'EMD Voucher' : 'checkout';

  products.forEach(product => {
    if (product && product.id === 'UPG') {
      product.name = 'Upgrade';
      product.variant = 'NA';
    }
  });

  products.forEach(productItem => {
    if (productItem.quantity && (productItem.quantity > 1)) {
      productItem.variant = 'NA';
    }

    if (productItem.id === 'SVI') {
      if (productItem.variant === 'NA') {
        productItem.variant = 'Adult';
      }
    }
  });

  return userProfile.hasOwnProperty('ffNumber') ? {
    event: 'checkout',
    clubpremierIDP: userProfile.hasOwnProperty('ffNumber') ? userProfile.ffNumber : '',
    currencyCode: cart.getCartCurrencyCode(),
    typeofPayment: typeofPaymentOnHoldPointsOrNormalFlowMYB,
    ticketNumber: '',
    pointsValue,
    revenueMYB: cart.getAmountTotal(),
    pointsCP: userProfile.account.balance,
    ecommerce: {
      checkout: {
        actionField: {
          step: 1,
          action: action,
        },
        products: products,
      },
    },
  } : {
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: {
          step: 1,
          affiliation: 'MYB',
          action: action,
        },
        products: products,
      },
    },
  };
};
